<template>
    <section class="assignments">
        {{getCourses}}
        <div class="panel" v-if="currentTerm">
            <div class="panel-heading">
                <h2><img src="../assets/img/assignment-icon.png">Assignments<i class="clippie fa fa-info-circle" v-tooltip="'A sortable assignment table including due dates, marks and recorded feedback.'"></i></h2>
                <div v-if="hasCourseSets && currentTerm.courseSets && currentTerm.courseSets.length > 0" class="course-set-switcher">
                    <ul>
                        <li v-for="set in currentTerm.courseSets">
                            <span
                            @click.prevent="selectCourseSet(set.id)"
                            :class="{'selected': currentTerm.selectedCourseSet == set.id}"
                            href="#">
                                {{set.name}}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="panel-body" v-if="courses">
                <assignments-table :courses="courses"></assignments-table>
            </div>
        </div>
    </section>
</template>
<script>
import assignmentsTable from './reusable/assignments-table/AssignmentsTable.vue';

export default {
    data() {
        return {
            courses: null
        }
    },
    components: {
        'assignments-table': assignmentsTable
    },
    methods: {
        selectCourseSet(id) {
            var self = this;
            this.$store.dispatch('update', { type: 'currentTerm', fields: { selectedCourseSet: id } });
            this.$store.getters.terms.forEach(function(term, index) {

                if (term.id == self.currentTerm.id) {
                    term.selectedCourseSet = id;
                    self.$store.dispatch('replace', { type: 'terms', data: { object: term, index: index } })
                }
            });

            if (!localStorage.selectedCourseSets || localStorage.selectedCourseSets === 'undefined') { localStorage.setItem('selectedCourseSets', '{}') };

            let selected = JSON.parse(localStorage.selectedCourseSets);
            selected[self.currentTerm.id] = id;
            localStorage.setItem('selectedCourseSets', JSON.stringify(selected));
        },
    },
    computed: {
        getCourses() {
            if (this.$store.getters.courses && this.$store.getters.courses.length > 0) {
                this.courses = this.$store.getters.courses
            }
        },
        currentTerm() {
            return this.$store.getters.currentTerm;
        },
        hasCourseSets() {
            return localStorage.has_course_sets === 'true';
        },
    }

}

</script>
<style lang="scss" scoped>
.panel-heading {
    h2 {
        display: inline-block !important;
        width: auto !important;
    }
}

.course-set-switcher {
    display: inline-block;
    padding-left: 3rem;

    ul {
        display:flex;
        text-align: center;
        padding:5px;
        align-items: center;
        justify-content: space-between;
        li {
            padding:0 1rem;

        }
        li:first-child {
            padding-right:.5rem;
        }
        li:first-child span::after {
            content:'/';
            position: absolute;
            right:-1.1rem;
            color:#fff!important;
            top:0;
        }
    }

    span {
        position: relative;
        color: #fff;
        cursor: pointer;
    }

    span.selected {
        color: #3cf;
        text-decoration: underline;
    }
}

.assignments {
    h2 img {
        margin-right: 1rem;
    }
}

</style>



// WEBPACK FOOTER //
// Assignments.vue?f2fd935e